import * as Sentry from "@sentry/react";
import React from "react";

import ComponentLoader from "../../../../components/Spinner/ComponentLoader";
import SurveyDetails from "./SurveyDetails";

import { getFeatureFlagQuery, useFeatureFlagQuery } from "../../../../hooks/useFeatureFlag";

import { currentUserQuery } from "../../../../api/queries";
import { SimplifiedQuery, dataLoader } from "../../../../api/queries/dataLoader";

import ErrorPage from "../../../Error";

// Data loader function
export const surveyDetailsLoader = () => {
	const queries: (() => SimplifiedQuery)[] = [getFeatureFlagQuery];

	return dataLoader([[currentUserQuery], queries]);
};

const SurveyDetailsPage: React.FC = () => {
	const {
		value: ffSurveys,
		query: { isLoading: isLoadingFFSurveys },
	} = useFeatureFlagQuery("ff-is-surveys-enabled", false);

	if (isLoadingFFSurveys) {
		return <ComponentLoader />;
	}

	if (!ffSurveys) {
		return <ErrorPage code={403} />;
	}

	return (
		<Sentry.ErrorBoundary fallback={undefined}>
			<SurveyDetails />
		</Sentry.ErrorBoundary>
	);
};

export default SurveyDetailsPage;
